import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {Exam} from '../../../../data/model/exam';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'show-exam-dialog',
  templateUrl: './show-exam-dialog.html',
  styleUrls: ['./show-exam-component.scss']
})
export class ShowExamDialogComponent {

  topExam: Exam;
  rows: Exam[];

  constructor(
      public dialogRef: MatDialogRef<ShowExamDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.rows = data.exams;

    let ex: Exam = null;
    data.exams.forEach(exam => {
        if (ex === null) {
          ex = exam;
        } else {
          if (exam.percentage_correct > ex.percentage_correct) {
            ex = exam;
          }
          if (exam.has_passed){
            ex = exam;
          }
        }
    });
    this.topExam = ex;
  }

  colorScheme = {domain: ['#5AA454']};

  single = [{'name': 'Completed', 'value': 40}];

  view: any[] = [200, 200];
  smallView: any[] = [150, 150];

  onNoClick(): void {
    this.dialogRef.close();
  }
  openImageUpload() {
    document.getElementById('image-id').click();
  }

  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(message: string) {
    this.dialogRef.close(message);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/progress/exam/show.exam.dialog.component.ts